
//#fff100
const abctheme = {
    basefontcolor:'#2f2f2f',
    basecolor:'#afd9ba',
    //#afd9ba #85c56f
    basefzcolor:'#85c56f',
    baseocolor:'#d0fac2',
    fz1color:'rgb(244, 13, 100)',
    fz2color:'rgb(175,18,88)',
    fz3color:'rgb(90,13,67)',
    fz4color:'rgb(179,197,135)',
    fz5color:'#00a1e9',
    fontsm:'12px',
    fontbase:'14px',
    fontlg:'16px',
    fontbig:'26px',
    colorprimary:'rgb(234,246,96)',
    colorsuccess: 'rgb(156,212,203)',
    colorwarning: 'rgb(252,174,187)',
    colorerror: '#dd524d'
}
export default abctheme